/* ==========================================================================
   SWAY URBAN — Interactions (safe, self-contained, no dependencies)
   ========================================================================== */
(function () {
  "use strict";

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- 1. Scroll reveal ------------------------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll(".su-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("su-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("su-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) { io.observe(el); });

    // Section-header accent underline draw-in
    document.querySelectorAll(".section-header").forEach(function (h) {
      io.observe(h);
      var io2 = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("su-in"); io2.unobserve(x.target); } });
      }, { threshold: 0.2 });
      io2.observe(h);
    });
  }

  /* ---- 2. Marquee: duplicate track for seamless loop ------------------- */
  function initMarquee() {
    document.querySelectorAll(".su-marquee__track, .su-revscroll__track").forEach(function (track) {
      if (track.dataset.suCloned) return;
      var clone = track.innerHTML;
      track.innerHTML = clone + clone; // 2x so translateX(-50%) loops seamlessly
      track.dataset.suCloned = "1";
    });
  }

  /* ---- 3. Countdown timers -------------------------------------------- */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  function initCountdowns() {
    var timers = document.querySelectorAll("[data-su-countdown]");
    if (!timers.length) return;

    timers.forEach(function (t) {
      var mode = t.getAttribute("data-su-mode") || "date";
      var target;

      if (mode === "daily") {
        // resets to end of today, every day
        var recompute = function () {
          var now = new Date();
          var end = new Date(now);
          end.setHours(23, 59, 59, 0);
          if (end <= now) end.setDate(end.getDate() + 1);
          return end.getTime();
        };
        target = recompute();
        t._recompute = recompute;
      } else {
        var raw = t.getAttribute("data-su-date"); // YYYY-MM-DD or YYYY-MM-DDTHH:MM
        var parsed = raw ? new Date(raw.replace(" ", "T")) : NaN;
        target = isNaN(parsed) ? Date.now() + 86400000 : parsed.getTime();
      }

      var nums = {
        d: t.querySelector('[data-u="d"]'),
        h: t.querySelector('[data-u="h"]'),
        m: t.querySelector('[data-u="m"]'),
        s: t.querySelector('[data-u="s"]')
      };
      var last = {};

      function set(el, val) {
        if (!el) return;
        var str = pad(val);
        if (el.textContent !== str) {
          el.textContent = str;
          if (!reduce) {
            el.classList.remove("su-tick");
            void el.offsetWidth;
            el.classList.add("su-tick");
          }
        }
      }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (mode === "daily" && t._recompute) { target = t._recompute(); diff = target - Date.now(); }
          else { diff = 0; }
        }
        var s = Math.floor(diff / 1000);
        set(nums.d, Math.floor(s / 86400));
        set(nums.h, Math.floor((s % 86400) / 3600));
        set(nums.m, Math.floor((s % 3600) / 60));
        set(nums.s, s % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---- 4. Sticky add-to-cart (product pages) --------------------------- */
  function initStickyATC() {
    if (document.querySelector(".su-sticky-atc")) return; // guard
    var main = document.querySelector('main[data-template="product"]');
    if (!main) return;
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    var submit = form && form.querySelector('[type="submit"], .product-form__submit');
    if (!form || !submit) return;

    var titleEl = document.querySelector(".product__title h1, .product__title, h1");
    var priceEl = document.querySelector(".price .price-item--sale, .price .price-item--regular, .price-item");
    var title = titleEl ? titleEl.textContent.trim() : "Add to cart";
    var price = priceEl ? priceEl.textContent.trim() : "";

    var bar = document.createElement("div");
    bar.className = "su-sticky-atc";
    bar.innerHTML =
      '<div class="su-sticky-atc__info">' +
        '<div class="su-sticky-atc__title">' + title + "</div>" +
        '<div class="su-sticky-atc__price">' + price + "</div>" +
      "</div>" +
      '<button type="button" class="su-sticky-atc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    bar.querySelector(".su-sticky-atc__btn").addEventListener("click", function () {
      submit.click();
      if (typeof submit.scrollIntoView === "function" && document.querySelector(".product-form__error-message-wrapper")) {
        // if there is a variant error, bring the form into view
      }
    });

    // keep sticky price in sync when variant changes
    var priceObserverTarget = document.querySelector(".price");
    if (priceObserverTarget && "MutationObserver" in window) {
      new MutationObserver(function () {
        var p = priceObserverTarget.querySelector(".price-item--sale, .price-item--regular, .price-item");
        if (p) bar.querySelector(".su-sticky-atc__price").textContent = p.textContent.trim();
      }).observe(priceObserverTarget, { subtree: true, childList: true, characterData: true });
    }

    var anchor = submit.closest("product-form") || submit;
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // show sticky bar only when the real button is OUT of view
          bar.classList.toggle("su-show", !e.isIntersecting);
        });
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* ---- 5. Back to top -------------------------------------------------- */
  function initBackToTop() {
    if (document.querySelector(".su-top")) return; // guard
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "su-top";
    btn.setAttribute("aria-label", "Back to top");
    btn.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    });
    var toggle = function () { btn.classList.toggle("su-show", window.scrollY > 600); };
    window.addEventListener("scroll", toggle, { passive: true });
    toggle();
  }

  /* ---- 6. Floating WhatsApp button ------------------------------------ */
  function initWhatsApp() {
    if (document.querySelector(".su-wa")) return; // guard
    var phone = "919654293365"; // Sway Urban WhatsApp (change here if needed)
    var msg = encodeURIComponent("Hi Sway Urban! I'm interested in your products.");
    var a = document.createElement("a");
    a.className = "su-wa";
    a.href = "https://wa.me/" + phone + "?text=" + msg;
    a.target = "_blank";
    a.rel = "noopener";
    a.setAttribute("aria-label", "Chat on WhatsApp");
    a.innerHTML =
      '<svg viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.712 6.403L3.2 28.8l6.57-1.723a12.74 12.74 0 0 0 6.233 1.59h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.052A12.71 12.71 0 0 0 16.003 3.2zm0 23.36h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.003 1.05 1.068-3.9-.252-.4a10.56 10.56 0 0 1-1.62-5.6c0-5.868 4.774-10.64 10.64-10.64a10.57 10.57 0 0 1 7.52 3.118 10.57 10.57 0 0 1 3.115 7.526c0 5.867-4.773 10.64-10.64 10.64zm5.834-7.968c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.572-1.587-.95-.848-1.593-1.895-1.78-2.215-.187-.32-.02-.492.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.987-2.375-.26-.624-.524-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.827.763.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.892-.773 2.16-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z"/></svg>';
    document.body.appendChild(a);
  }

  /* ---- 7. 3D tilt / parallax on .su-tilt elements ---- */
  function initTilt() {
    if (reduce) return;
    var els = document.querySelectorAll(".su-tilt");
    els.forEach(function (el) {
      var max = parseFloat(el.getAttribute("data-tilt")) || 8;
      function move(e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform =
          "perspective(900px) rotateY(" + (px * max).toFixed(2) + "deg) rotateX(" + (-py * max).toFixed(2) + "deg)";
      }
      function reset() { el.style.transform = "perspective(900px) rotateY(0) rotateX(0)"; }
      var parent = el.closest("[data-tilt-area]") || el;
      parent.addEventListener("mousemove", move);
      parent.addEventListener("mouseleave", reset);
    });
  }

  /* ---- 8. Product page: size chart + delivery + urgency ---- */
  function isProduct() { return !!document.querySelector('main[data-template="product"]'); }

  function initProductExtras() {
    if (!isProduct()) return;
    var anchor =
      document.querySelector(".product-form") ||
      document.querySelector('.product__info-container .price') ||
      document.querySelector(".product__info-container");
    if (!anchor) return;

    // Size chart button + modal
    if (!document.querySelector(".su-sizebtn")) {
      var btn = document.createElement("button");
      btn.type = "button"; btn.className = "su-sizebtn";
      btn.innerHTML = '&#128207; Size Chart';
      var modal = document.createElement("div");
      modal.className = "su-modal";
      modal.innerHTML =
        '<div class="su-modal__box"><button class="su-modal__x" aria-label="Close">&times;</button>' +
        '<h3>Size Chart</h3>' +
        '<table><thead><tr><th>Size</th><th>Chest (in)</th><th>Length (in)</th><th>Shoulder (in)</th></tr></thead><tbody>' +
        '<tr><td>S</td><td>38</td><td>27</td><td>17</td></tr>' +
        '<tr><td>M</td><td>40</td><td>28</td><td>18</td></tr>' +
        '<tr><td>L</td><td>42</td><td>29</td><td>19</td></tr>' +
        '<tr><td>XL</td><td>44</td><td>30</td><td>20</td></tr>' +
        '<tr><td>XXL</td><td>46</td><td>31</td><td>21</td></tr>' +
        '</tbody></table><p style="margin-top:14px;font-size:.85rem;opacity:.7;">Measurements are approximate. Our tees have an oversized fit.</p></div>';
      document.body.appendChild(modal);
      btn.addEventListener("click", function () { modal.classList.add("su-open"); });
      modal.addEventListener("click", function (e) {
        if (e.target === modal || e.target.classList.contains("su-modal__x")) modal.classList.remove("su-open");
      });
      anchor.parentNode.insertBefore(btn, anchor);
    }

    // Urgency + delivery estimate
    if (!document.querySelector(".su-deliv")) {
      var wrap = document.createElement("div");
      var d = new Date(); d.setDate(d.getDate() + 5);
      var by = d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
      wrap.innerHTML =
        '<div class="su-urgency">Selling fast &middot; ships in 24-48h</div>' +
        '<div class="su-deliv">&#128666; Order now &mdash; estimated delivery by <b>&nbsp;' + by + "</b></div>";
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    }
  }

  /* ---- 9. Free-shipping progress bar (reads live cart) ---- */
  function initShipBar() {
    var THRESHOLD = 999; // Rs
    var header = document.querySelector("sticky-header, .header-wrapper, header");
    if (!header) return;
    var bar = document.createElement("div");
    bar.className = "su-ship"; bar.style.display = "none";
    header.parentNode.insertBefore(bar, header.nextSibling);
    function render(cart) {
      var total = (cart.total_price || 0) / 100;
      if (!cart.item_count) { bar.style.display = "none"; return; }
      bar.style.display = "block";
      if (total >= THRESHOLD) {
        bar.innerHTML = "&#127881; You&#39;ve unlocked <b>FREE shipping!</b>";
      } else {
        var left = Math.ceil(THRESHOLD - total);
        var pct = Math.min(100, (total / THRESHOLD) * 100);
        bar.innerHTML = "Add <b>&#8377;" + left + "</b> more for FREE shipping" +
          '<div class="su-ship__track"><div class="su-ship__fill" style="width:' + pct + '%"></div></div>';
      }
    }
    function fetchCart() { fetch("/cart.js").then(function (r) { return r.json(); }).then(render).catch(function(){}); }
    fetchCart();
    document.addEventListener("cart:updated", fetchCart);
    document.addEventListener("cart:refresh", fetchCart);
    // re-check after add-to-cart clicks
    document.addEventListener("click", function (e) {
      if (e.target.closest('[name="add"], .product-form__submit, .quick-add__submit')) setTimeout(fetchCart, 900);
    });
  }

  /* ---- 10. Discount / exit-intent popup (once per session) ---- */
  function initExitPopup() {
    if (sessionStorage.getItem("su_pop")) return;
    var pop = document.createElement("div");
    pop.className = "su-pop";
    pop.innerHTML =
      '<div class="su-pop__box">' +
      '<button class="su-pop__x" aria-label="Close">&times;</button>' +
      '<div class="su-pop__tag">Limited Offer</div>' +
      '<h3 class="su-pop__h">Unlock <span>10% Off</span></h3>' +
      '<p class="su-pop__p">Join the Sway Urban list and get 10% off your first order.</p>' +
      '<div class="su-pop__code"><span>SWAY10</span><button type="button" class="su-pop__copy">Copy</button></div>' +
      '<input type="email" class="su-pop__email" placeholder="Enter your email" inputmode="email">' +
      '<button type="button" class="su-pop__go">Claim My Discount</button>' +
      '<div class="su-pop__fine">No spam. Unsubscribe anytime.</div>' +
      "</div>";
    document.body.appendChild(pop);
    function show() {
      if (sessionStorage.getItem("su_pop")) return;
      pop.classList.add("su-open"); sessionStorage.setItem("su_pop", "1");
    }
    pop.addEventListener("click", function (e) {
      if (e.target === pop || e.target.classList.contains("su-pop__x")) pop.classList.remove("su-open");
      if (e.target.classList.contains("su-pop__copy")) {
        try { navigator.clipboard.writeText("SWAY10"); } catch (er) {}
        e.target.textContent = "Copied!";
        if (window.suToast) window.suToast("Code SWAY10 copied");
      }
      if (e.target.classList.contains("su-pop__go")) {
        try { navigator.clipboard.writeText("SWAY10"); } catch (er) {}
        pop.classList.remove("su-open");
        window.location.href = "/collections/all";
      }
    });
    setTimeout(show, 15000); // after 15s
    document.addEventListener("mouseout", function (e) { if (e.clientY < 10) show(); }); // exit intent
  }

  /* ---- 11. Wishlist (localStorage, hearts on cards + header count) ---- */
  function suWish() { try { return JSON.parse(localStorage.getItem("su_wish") || "[]"); } catch (e) { return []; } }
  function suWishSave(a) { localStorage.setItem("su_wish", JSON.stringify(a)); document.dispatchEvent(new Event("su:wish")); }
  function initWishlist() {
    var cards = document.querySelectorAll(".card-wrapper, .card");
    var list = suWish();
    cards.forEach(function (card) {
      if (card.querySelector(".su-wish-btn")) return;
      var link = card.querySelector("a[href*='/products/']");
      if (!link) return;
      var url = link.getAttribute("href").split("?")[0];
      var media = card.querySelector(".card__media, .media") || card;
      if (getComputedStyle(media).position === "static") media.style.position = "relative";
      var b = document.createElement("button");
      b.type = "button"; b.className = "su-wish-btn"; b.setAttribute("aria-label", "Add to wishlist");
      b.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.9-10-9.2C.4 8.9 1.6 5.5 4.8 5.1 6.8 4.9 8.4 6 12 8.5c3.6-2.5 5.2-3.6 7.2-3.4 3.2.4 4.4 3.8 2.8 6.7C19.5 16.1 12 21 12 21z"/></svg>';
      if (list.indexOf(url) > -1) b.classList.add("su-active");
      b.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var arr = suWish(); var i = arr.indexOf(url);
        if (i > -1) { arr.splice(i, 1); b.classList.remove("su-active"); if (window.suToast) window.suToast("Removed from wishlist"); }
        else { arr.push(url); b.classList.add("su-active"); if (window.suToast) window.suToast("&#10084; Saved to wishlist"); }
        suWishSave(arr);
      });
      media.appendChild(b);
    });
    // header count badge
    var cartIcon = document.querySelector('#cart-icon-bubble, a[href="/cart"], .header__icon--cart');
    if (cartIcon && !document.querySelector(".su-wish-count-wrap")) {
      var span = document.createElement("span");
      span.className = "su-wish-count-wrap";
      function upd() {
        var n = suWish().length;
        span.innerHTML = n ? '<span class="su-wish-count">' + n + "</span>" : "";
      }
      document.addEventListener("su:wish", upd); upd();
      cartIcon.parentNode.insertBefore(span, cartIcon);
    }
  }

  /* ---- 12. Smooth scroll (Lenis if available) ---- */
  function initLenis() {
    if (reduce || typeof window.Lenis === "undefined") return;
    try {
      var lenis = new window.Lenis({ duration: 1.1, smoothWheel: true });
      function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      window.__suLenis = lenis;
    } catch (e) {}
  }

  /* ---- 13. Scroll progress bar ---- */
  function initProgress() {
    var bar = document.createElement("div");
    bar.className = "su-progress";
    document.body.appendChild(bar);
    function upd() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + "%";
    }
    window.addEventListener("scroll", upd, { passive: true }); upd();
  }

  /* ---- 14. Page load intro (once per session) ---- */
  function initIntro() {
    if (reduce || sessionStorage.getItem("su_intro")) return;
    sessionStorage.setItem("su_intro", "1");
    var el = document.createElement("div");
    el.className = "su-intro";
    el.innerHTML = '<div class="su-intro__logo"><span>SWAY</span> <span>URBAN</span></div>';
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add("su-gone"); }, 1100);
    setTimeout(function () { el.remove(); }, 2000);
  }

  /* ---- 15. Custom cursor (desktop) ---- */
  function initCursor() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches || reduce) return;
    var dot = document.createElement("div");
    dot.className = "su-cursor";
    document.body.appendChild(dot);
    document.body.classList.add("su-has-cursor");
    var x = 0, y = 0, cx = 0, cy = 0;
    document.addEventListener("mousemove", function (e) { x = e.clientX; y = e.clientY; });
    (function loop() {
      cx += (x - cx) * 0.2; cy += (y - cy) * 0.2;
      dot.style.left = cx + "px"; dot.style.top = cy + "px";
      requestAnimationFrame(loop);
    })();
    document.addEventListener("mouseover", function (e) {
      if (e.target.closest("a, button, .card, .su-cat, .su-tee")) dot.classList.add("su-cursor--hover");
    });
    document.addEventListener("mouseout", function (e) {
      if (e.target.closest("a, button, .card, .su-cat, .su-tee")) dot.classList.remove("su-cursor--hover");
    });
    document.addEventListener("mousedown", function () { dot.classList.add("su-cursor--down"); });
    document.addEventListener("mouseup", function () { dot.classList.remove("su-cursor--down"); });
  }

  /* ---- 16. Magnetic buttons (desktop) ---- */
  function initMagnetic() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches || reduce) return;
    document.querySelectorAll(".su-btn, .button, .product-form__submit").forEach(function (b) {
      b.addEventListener("mousemove", function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = "translate(" + (e.clientX - r.left - r.width / 2) * 0.25 + "px," + (e.clientY - r.top - r.height / 2) * 0.35 + "px)";
      });
      b.addEventListener("mouseleave", function () { b.style.transform = ""; });
    });
  }

  /* ---- 17. Animated sticky header ---- */
  function initHeaderScroll() {
    var last = 0;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      document.body.classList.toggle("su-scrolled", y > 40);
      last = y;
    }, { passive: true });
  }

  /* ---- 18. Toasts ---- */
  function ensureToastWrap() {
    var w = document.querySelector(".su-toast-wrap");
    if (!w) { w = document.createElement("div"); w.className = "su-toast-wrap"; document.body.appendChild(w); }
    return w;
  }
  window.suToast = function (msg) {
    var w = ensureToastWrap();
    var t = document.createElement("div");
    t.className = "su-toast"; t.innerHTML = msg;
    w.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("su-show"); });
    setTimeout(function () { t.classList.remove("su-show"); setTimeout(function () { t.remove(); }, 400); }, 2600);
  };

  /* ---- 19. Add-to-cart fly animation + cart bump + toast ---- */
  function initAtcFly() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest('.product-form__submit, [name="add"], .quick-add__submit');
      if (!btn) return;
      var cart = document.querySelector("#cart-icon-bubble, .header__icon--cart");
      var img = (btn.closest(".card, .product, .grid__item, main") || document).querySelector(".card__media img, .product__media img, img");
      if (cart && img) {
        var ir = img.getBoundingClientRect(), cr = cart.getBoundingClientRect();
        var fly = img.cloneNode(true);
        fly.className = "su-fly";
        fly.style.left = ir.left + "px"; fly.style.top = ir.top + "px";
        fly.style.width = ir.width + "px"; fly.style.height = ir.height + "px";
        document.body.appendChild(fly);
        requestAnimationFrame(function () {
          fly.style.left = cr.left + cr.width / 2 + "px";
          fly.style.top = cr.top + cr.height / 2 + "px";
          fly.style.width = "24px"; fly.style.height = "24px"; fly.style.opacity = "0.2";
        });
        setTimeout(function () { fly.remove(); cart.classList.add("su-cart-bump"); setTimeout(function(){ cart.classList.remove("su-cart-bump"); }, 400); }, 850);
      }
      setTimeout(function () { if (window.suToast) window.suToast("&#10004; Added to cart"); }, 400);
    });
  }

  /* ---- 20. Hero headline word reveal ---- */
  function initHeroReveal() {
    var t = document.querySelector(".su-hero__title");
    if (!t || t.dataset.suDone) return;
    t.dataset.suDone = "1";
    var html = t.innerHTML;
    // wrap plain text words (keep existing <span> for the accent word)
    var tmp = document.createElement("div"); tmp.innerHTML = html;
    var out = "";
    tmp.childNodes.forEach(function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(function (w) {
          if (w.trim()) out += '<span class="su-word"><span>' + w + "</span></span>";
          else out += w;
        });
      } else {
        out += '<span class="su-word"><span>' + n.outerHTML + "</span></span>";
      }
    });
    t.innerHTML = out;
  }

  /* ---- 21. Auto reveal product cards (staggered) ---- */
  function enhanceReveal() {
    document.querySelectorAll(".card-wrapper, .su-review, .su-usp__item").forEach(function (el, i) {
      if (!el.classList.contains("su-reveal")) {
        el.classList.add("su-reveal", "su-delay-" + (i % 3));
      }
    });
  }

  /* ---- 22. Endless scroll: more products from this collection ---- */
  function initMoreProducts() {
    var box = document.querySelector("#su-more");
    if (!box) return;
    var handle = box.getAttribute("data-handle") || "all";
    var grid = box.querySelector(".su-more__grid");
    var sentinel = box.querySelector(".su-more__sentinel");
    var loading = box.querySelector(".su-more__loading");
    var page = 1, done = false, busy = false;
    function load() {
      if (busy || done) return;
      busy = true; if (loading) loading.style.display = "block";
      fetch("/collections/" + handle + "?page=" + page)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var items = doc.querySelectorAll("#product-grid .grid__item, .product-grid .grid__item, li.grid__item");
          if (!items.length) { done = true; if (loading) loading.style.display = "none"; return; }
          items.forEach(function (it) {
            var card = it.querySelector(".card-wrapper") || it;
            var clone = card.cloneNode(true);
            var w = document.createElement("div");
            w.appendChild(clone);
            grid.appendChild(w.firstChild);
          });
          page++; busy = false; if (loading) loading.style.display = "none";
          try { initWishlist(); enhanceReveal(); } catch (e) {}
        })
        .catch(function () { done = true; busy = false; if (loading) loading.style.display = "none"; });
    }
    if ("IntersectionObserver" in window && sentinel) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) load(); });
      }, { rootMargin: "400px" }).observe(sentinel);
    }
    load();
  }

  function init() {
    try { initIntro(); } catch (e) {}
    try { initProgress(); } catch (e) {}
    try { initLenis(); } catch (e) {}
    try { initCursor(); } catch (e) {}
    try { initMagnetic(); } catch (e) {}
    try { initHeaderScroll(); } catch (e) {}
    try { initAtcFly(); } catch (e) {}
    try { initHeroReveal(); } catch (e) {}
    try { enhanceReveal(); } catch (e) {}
    try { initReveal(); } catch (e) {}
    try { initMarquee(); } catch (e) {}
    try { initCountdowns(); } catch (e) {}
    try { initStickyATC(); } catch (e) {}
    try { initBackToTop(); } catch (e) {}
    try { initWhatsApp(); } catch (e) {}
    try { initTilt(); } catch (e) {}
    try { initProductExtras(); } catch (e) {}
    try { initShipBar(); } catch (e) {}
    try { initExitPopup(); } catch (e) {}
    try { initWishlist(); } catch (e) {}
    try { initMoreProducts(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-run reveal/marquee when sections are edited in the theme customizer
  document.addEventListener("shopify:section:load", function () {
    try { initReveal(); } catch (e) {}
    try { initMarquee(); } catch (e) {}
    try { initCountdowns(); } catch (e) {}
    try { initTilt(); } catch (e) {}
    try { initWishlist(); } catch (e) {}
    try { enhanceReveal(); } catch (e) {}
    try { initHeroReveal(); } catch (e) {}
  });
})();
